import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryVM} from "../../models/CategoryVM.model";
import {CategoryService} from "../../services/category/category.service";
import {ServantVM, ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServantService} from "../../services/servant-service/servant-service";


@Component({

  selector: 'rw-category-service-list',  // <home></home>

  styles: [require('./category-service-list.component.css')],

  template: require('./category-service-list.component.html')
})

export class CategoryServiceListComponent implements OnInit,OnChanges {

  @Input() public serviceList:ServiceItemVM[];
  @Input() public selectedServant:ServantVM;



  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute:ActivatedRoute,
              private companyService:CompanyService,
              private categoryService:CategoryService,
              ) {
  }


  private imageList:ImageVM[];

  public ngOnInit() {

  }

  onServiceExpanded(si) {
    let parent = this;

    if (si && !si.detail) {
      parent.categoryService.getServiceItemDetailById(si.id).subscribe((sdetail)=> {
          si.detail = sdetail;
          parent.setDuration(si.detail);
          this.getServiceImage(si.detail);
        })
    }


  }
  checkSelectedServant(si){
    if (si && this.selectedServant){
      si.servantId = this.selectedServant.id;
    }
  }
  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;
      }
  getServiceImage(si:ServiceItemDetailVM) {
    let parent = this;
    if (si && si.imageAlbum && si.imageAlbum.imageList && si.imageAlbum.imageList.length > 0) {

      si.coverImage = si.imageAlbum.imageList[0];
    }
  }
  setDuration(sd) {
    if (sd.scheduleInfo && sd.scheduleInfo.weeklyScheduleInfo && sd.scheduleInfo.weeklyScheduleInfo.timePeriod) {
      sd.duration = sd.scheduleInfo.weeklyScheduleInfo.timePeriod.duration;
    }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/category-service-list/category-service-list.component.ts